// extracted by mini-css-extract-plugin
export default {"AboutUs_container":"about_AboutUs_container__HIwNA"};